import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from './components/tools/index'
import { Footer,Sections } from './components/ui/index'
import { Login } from './components/login/index'
import { AuthProvider, GeneralProvider } from './context/index';
import { PageNotFound404 } from "./PageNotFound404";
import { Pruebas } from "./components/Pruebas";
import { useEffect, useState } from "react";
import { BUILD_INFO } from "./buildInfo";

function VersionWatcher() {
    const [showReloadModal, setShowReloadModal] = useState(false)
    const [secondsLeft, setSecondsLeft] = useState(10)

    useEffect(() => {
        let cancelled = false
        let countdownIntervalId = null

        const startReloadCountdown = () => {
            if (countdownIntervalId) {
                return
            }

            setShowReloadModal(true)
            setSecondsLeft(10)

            countdownIntervalId = window.setInterval(() => {
                setSecondsLeft((currentSeconds) => {
                    if (currentSeconds <= 1) {
                        window.location.reload()
                        return 0
                    }

                    return currentSeconds - 1
                })
            }, 1000)
        }

        const checkForNewVersion = async () => {
            try {
                const response = await fetch(`/version.json?t=${Date.now()}`, {
                    cache: 'no-store',
                })

                if (!response.ok) {
                    return
                }

                const remoteBuildInfo = await response.json()

                if (!cancelled && remoteBuildInfo?.buildId && remoteBuildInfo.buildId !== BUILD_INFO.buildId) {
                    startReloadCountdown()
                }
            } catch (error) {
                // silencio intencional: el polling no debe romper la app
            }
        }

        checkForNewVersion()
        const intervalId = window.setInterval(checkForNewVersion, 30000)

        return () => {
            cancelled = true
            window.clearInterval(intervalId)
            if (countdownIntervalId) {
                window.clearInterval(countdownIntervalId)
            }
        }
    }, [])

    return (
        showReloadModal
            ? (
                <dialog open className='modalBackdrop justify-content-center'>
                    <div className='modalContent clrBgLightGray p-0'>
                        <div className='p-2 clrBgPink d-flex justify-content-between'>
                            <h5 className='m-0 fw-bold'>NUEVA VERSION DISPONIBLE</h5>
                        </div>
                        <div className='p-4'>
                            <p className='mb-2'>
                                Se detecto una nueva version del portal.
                            </p>
                            <p className='mb-4'>
                                La pagina se va a recargar automaticamente en {secondsLeft} segundos.
                            </p>
                            <div className='d-flex justify-content-end gap-2'>
                                <button
                                    type='button'
                                    className='btn btn-outline btnBlue'
                                    onClick={() => window.location.reload()}
                                >
                                    Recargar ahora
                                </button>
                            </div>
                        </div>
                    </div>
                </dialog>
            )
            : null
    )
}

function App() {

    return (
        <div className="App">
            <AuthProvider>
                <GeneralProvider>
                    <VersionWatcher />
                    {/* Creamos rutas de navegacion */}
                    <Router>

                        <Routes>
                            {/* cualquier ruta te lleva a login */}
                            <Route path="/*" element={<Navigate to="/login" />} />

                            <Route path="/login" element={<Login />} />

                            <Route path="/sections/*" element=
                                {
                                    <ProtectedRoute>

                                        <Sections />

                                    </ProtectedRoute>
                                }
                            />

                            <Route path="*" element={<PageNotFound404/>}/>
                             {/* <Route path="/test" element={<Pruebas/>}/> */}
                        </Routes>
                        <Footer />
                    </Router>
                </GeneralProvider>
            </AuthProvider>

        </div>
    );
}

export default App;
